import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { OrigamiResponse, ServiceBase } from './base/service.base';
import { Topic } from '@app/origami-api/utils/topic-utils';

export namespace DocumentTemplateServiceOptions {
  export interface GetDocumentTemplatesOptions {
    siteId: number;
    categoryId?: number;
    templateId?: number;
  }
}

@Injectable()
export class DocumentTemplateService extends ServiceBase {
  serviceUrl = 'DocumentTemplateService.svc';

  getDocumentTemplates(
    body: DocumentTemplateServiceOptions.GetDocumentTemplatesOptions,
    ...params
  ): Observable<OrigamiResponse<Topic[]>> {
    return this.origamiPost('/GetDocumentTemplates', body, ...params);
  }
}
